import { type Meta } from '../types/docs';
import {
  AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
  AUTOMATIONS_ANALYTICS_ENTRY_SOURCES,
  AUTOMATIONS_ANALYTICS_PROMPT_MODES,
  AUTOMATIONS_ANALYTICS_SCHEDULE_REPEATS,
} from './automationsAnalytics';

const META: Meta = {
  description: 'The user successfully created a new automation',
  name: 'automation_created',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'How the user entered the create flow',
      name: 'entry_source',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_ENTRY_SOURCES],
    },
    {
      description: 'Whether the automation uses a linked skill or a custom prompt',
      name: 'prompt_mode',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_PROMPT_MODES],
    },
    {
      description: 'Schedule repeat interval when a recurring schedule was set',
      name: 'schedule_repeat',
      required: false,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_SCHEDULE_REPEATS],
    },
  ],
};

export default META;
